exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customstyle{\r\n    top: 8px;\r\n    padding-left: 12px;\r\n    position: absolute;\r\n    width: 122px;\r\n}\r\n.custom_space{\r\n    margin-bottom: 31px;\r\n}\r\n@media (max-width: 1399px){\r\n    .form-horizontal .control-label {\r\n        font-size: 12px;\r\n    }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/account/account.component.css
// module id = ../../../../../src/app/account/account.component.css
// module chunks = main